module.exports = __webpack_public_path__ + "static/media/connect-agent-home.8a5a120b.svg";